// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as CatalogueCard from "./CatalogueCard.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var title = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.rem(1.5)),
      tl: {
        hd: BsCss.fontWeight({
              NAME: "num",
              VAL: 600
            }),
        tl: {
          hd: BsCss.paddingBottom(BsCss.rem(1.0)),
          tl: /* [] */0
        }
      }
    });

var subTitle = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.rem(56.0)),
      tl: /* [] */0
    });

var container = Curry._1(BsCss.style, {
      hd: BsCss.display("flex"),
      tl: {
        hd: BsCss.flexWrap("wrap"),
        tl: {
          hd: BsCss.marginLeft(BsCss.rem(-0.5)),
          tl: {
            hd: BsCss.marginRight(BsCss.rem(-0.5)),
            tl: {
              hd: BsCss.media("(min-width: 1024px)", {
                    hd: BsCss.marginLeft(BsCss.rem(-1.0)),
                    tl: {
                      hd: BsCss.marginRight(BsCss.rem(-1.0)),
                      tl: /* [] */0
                    }
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  title: title,
  subTitle: subTitle,
  container: container
};

function CatalogueCardList(props) {
  var skuDict = props.skuDict;
  return JsxRuntime.jsx("div", {
              children: Belt_Array.mapWithIndexU(props.catalogue, (function (i, card) {
                      return JsxRuntime.jsx(CatalogueCard.make, {
                                  card: card,
                                  position: i + 1 | 0,
                                  skuDict: Caml_option.some(Belt_Option.getWithDefault(skuDict, {}))
                                }, "eGifCard_" + card.uid);
                    })),
              className: container
            });
}

var SkuPresentation;

var make = CatalogueCardList;

export {
  SkuPresentation ,
  Styles ,
  make ,
}
/* title Not a pure module */
